'use client';

import { useCallback, useState } from 'react';
import classNames from 'classnames';
import Button from 'components/gruenland/atoms/button/Button';
import FeedbackIconLayer from 'components/gruenland/atoms/button/feedbackIconLayer';
import Drawer from 'components/gruenland/atoms/drawer/Drawer';
import FilterCount from 'components/gruenland/atoms/filters/FilterCount';
import { ChevronDown } from 'components/gruenland/icons/ChevronDown';
import { Close } from 'components/gruenland/icons/Close';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PLP_COUNT_LABEL } from 'lib/typography';
import DynamicFacets from './DynamicFacets';
import SortFacets from './SortFacets';
import { useProductList } from '../../context';

const Facets: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { activeRefinements, navigating, removeAllRefinements, facetsConfiguration, totalItems } = useProductList();

  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => {
    setIsOpen((x) => !x);
  }, []);
  const reset = useCallback(() => {
    removeAllRefinements();
    setIsOpen(false);
  }, [removeAllRefinements]);

  return (
    <>
      <div className="border-b border-neutral-400 pb-4 pt-12">
        <span className={classNames(TYPOGRAPHY_PLP_COUNT_LABEL, 'uppercase')}>
          {totalItems} {formatMessage({ id: 'plp.products', defaultMessage: 'Prodotti' })}
        </span>
      </div>
      <div className="flex items-center gap-5 py-8">
        <button className="flex items-center gap-2" onClick={toggle}>
          <span className="text-[14px]">{formatMessage({ id: 'plp.filters', defaultMessage: 'Filtri' })}</span>
          {activeRefinements.length > 0 && <FilterCount>{activeRefinements.length}</FilterCount>}
          <ChevronDown className="w-5" />
        </button>
        <SortFacets />
      </div>
      <Drawer isOpen={isOpen} onClose={toggle} direction="left" className="w-[90%] max-w-[400px]">
        <div className="relative flex items-center justify-between border-b border-neutral-400 px-3 py-4">
          <h3 className="text-[24px]/[32px] font-medium">
            {formatMessage({ id: 'plp.filtersDrawer.title', defaultMessage: 'Filtra prodotti' })}
          </h3>
          <button onClick={toggle}>
            <Close />
          </button>
        </div>
        <div className="grow overflow-auto">
          <DynamicFacets configuration={facetsConfiguration} />
        </div>

        <div className="flex w-full items-center gap-[18px] border-t bg-white px-[14px] py-[18px]">
          <Button variant="buttonSecondary" onClick={reset} className="w-full">
            {formatMessage({ id: 'plp.clearAll', defaultMessage: 'Azzera' })}
          </Button>
          <Button variant="buttonPrimaryBlack" className="w-full" onClick={toggle}>
            {formatMessage({ id: 'plp.showResults', defaultMessage: 'Mostra risultati' })}
          </Button>
          {navigating && <FeedbackIconLayer className="z-50 backdrop-opacity-50" loading />}
        </div>
      </Drawer>
    </>
  );
};

export default Facets;
